import React from "react";
import SeeMoreOrLess from "components/customs/text-see-more-or-see-less";
import { getFormattedContactNumber, getFormattedNumber } from "utility/helpers";
import { CellText } from "assets/js/Styles";
import styled from "styled-components";

const CellContainer = styled.p`
  width: 100%;
  align-items: center;
  margin: 0;
`;

const atcColumns = ({
  isTextExpanded,
  insertOrRemoveExpandedSeeMoreOrLessTexts,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "Name",
      selector: ({ principal }) => principal?.atc_name,
      identifier: "atc_name",
      grow: 2,
      minWidth: "150px",
      sortable: true,
      // eslint-disable-next-line camelcase
      cell: ({ first_name, last_name }) => (
        // eslint-disable-next-line camelcase
        <CellText>{`${last_name}, ${first_name}`}</CellText>
      ),
    },
    {
      name: "Province",
      // eslint-disable-next-line camelcase
      selector: ({ scope_province }) => scope_province?.name,
      identifier: "province",
      grow: 2,
      minWidth: "140px",
      sortable: true,
      // eslint-disable-next-line camelcase
      cell: ({ scope_province }) => (
        // eslint-disable-next-line camelcase
        <CellText>{scope_province?.name}</CellText>
      ),
    },
    {
      name: "Scope",
      // eslint-disable-next-line camelcase
      selector: ({ scope_municipalities }) => scope_municipalities,
      identifier: "scope",
      grow: 3,
      minWidth: "180px",
      sortable: false,
      // eslint-disable-next-line camelcase
      cell: ({ scope_municipalities, id }) => (
        <CellContainer>
          <SeeMoreOrLess
            // eslint-disable-next-line camelcase
            text={scope_municipalities
              ?.map((municipality) => municipality?.name)
              ?.join(", ")}
            id={`scope-${id}`}
            isTextExpanded={isTextExpanded}
            insertOrRemoveExpandedSeeMoreOrLessTexts={
              insertOrRemoveExpandedSeeMoreOrLessTexts
            }
          />
        </CellContainer>
      ),
    },
    {
      name: "Principal",
      // eslint-disable-next-line camelcase
      selector: ({ principal }) => principal?.atc_principal,
      identifier: "atc_principal",
      grow: 3,
      minWidth: "180px",
      sortable: true,
      cell: ({ principal }) => (
        // eslint-disable-next-line camelcase
        <CellText>
          {principal?.atc_principal?.replace(/none|None|NONE/g, "")}
        </CellText>
      ),
    },
    {
      name: "Principal Contact Number",
      // eslint-disable-next-line camelcase
      selector: ({ principal }) => principal?.atc_contact,
      identifier: "atc_contact",
      grow: 2,
      minWidth: "150px",
      sortable: false,
      cell: ({ principal }) => (
        <CellText>{getFormattedContactNumber(principal?.atc_contact)}</CellText>
      ),
    },
    {
      name: "cos",
      // eslint-disable-next-line camelcase
      selector: ({ principal }) => principal?.chief_of_staff,
      identifier: "chief_of_staff",
      grow: 2,
      minWidth: "150px",
      sortable: true,
      cell: ({ principal }) => (
        <CellText>
          {principal?.chief_of_staff?.replace(/none|None|NONE/g, "")}
        </CellText>
      ),
    },
    {
      name: "Cos Contact",
      // eslint-disable-next-line camelcase
      selector: ({ principal }) => principal?.chief_of_staff_contact,
      identifier: "chief_of_staff_contact",
      grow: 2,
      minWidth: "150px",
      sortable: false,
      cell: ({ principal }) => (
        <CellText>
          {getFormattedContactNumber(principal?.chief_of_staff_contact)}
        </CellText>
      ),
    },
    {
      name: "Allocations",
      selector: ({ allocations }) => allocations,
      identifier: "allocations",
      grow: 2,
      sortable: true,
      cell: ({ allocations }) => (
        <CellText>
          {!allocations || allocations === 0
            ? "PHP 0.00"
            : getFormattedNumber(allocations)}
        </CellText>
      ),
    },
    {
      name: "Expenditures",
      selector: ({ expenditures }) => expenditures,
      identifier: "expenditures",
      grow: 2,
      sortable: true,
      cell: ({ expenditures }) => (
        <CellText>
          {Number.isFinite(expenditures)
            ? getFormattedNumber(expenditures)
            : "PHP 0.00"}
        </CellText>
      ),
    },
    {
      name: "Remaining Balance",
      // eslint-disable-next-line camelcase
      selector: ({ remaining_balance }) => remaining_balance,
      identifier: "remaining_balance",
      grow: 2,
      sortable: true,
      // eslint-disable-next-line camelcase
      cell: ({ remaining_balance }) => (
        <CellText>
          {Number.isFinite(remaining_balance)
            ? getFormattedNumber(remaining_balance)
            : "PHP 0.00"}
        </CellText>
      ),
    },
  ];
};

export default atcColumns;
